<template>
  <div v-if="estimation && item">
    <table
      class="table has-tiny-font my-3"
      :class="{ 'is-fullwidth': isFullwidth }">
      <thead>
        <tr class="has-text-centered">
          <th 
            v-for="(header,i) in headers"
            :colspan="header.colspan"
            :class="header.class"
            :key="i">
            {{ header.label | uppercase }}
            <span 
              v-if="header.label == 'Area' && hasFootnotes"
              class="has-text-weight-normal">
              [1]
            </span>
          </th>
        </tr>
      </thead>

      <tbody>

        <template v-if="item.materials">
          <tr
            class="v-centered pricing__supply" 
            v-for="(material, materialIndex) in item.materials"
            :key="material.id">
            <template v-if="materialIndex == 0" >
              <!-- <td
                class="text--nowrap border--after"
                :rowspan="item.materials.length + item.processing.length + 
                item.fabrications.length + item.installations.length">
                {{ item.architecture_name }}
              </td> -->
              <td
                class="border--after rotate"
                :rowspan="item.materials.length + item.processing.length + 
                  item.fabrications.length">
                <div>Supply</div>
              </td>
              <td
                class="border--after"  
                :rowspan="item.materials.length + item.processing.length">
                Material
              </td>
            </template>
            <td>
              {{ material.product_master.product_category.category }}
            </td>
            <td class="border--after">
              {{ material.product_master.name }}
            </td>
            <td>
              {{ material.area | commasep(0) }}
            </td>
            <td class="border--after">
              {{ material.product_master.unit ? 
                material.product_master.unit.unit_display_name : '' }}
            </td>
            <td>
              {{ material.price | currency(0) }}
            </td>
          </tr>
        </template>

        <template v-else>
          <tr
            class="v-centered pricing__supply">
            <td
              class="border--after rotate"
              :rowspan="item.processing.length + item.fabrications.length">
              <div>Supply</div>
            </td>
            <td
              class="border--after"  
              :rowspan="item.processing.length">
              Material
            </td>
          </tr>
        </template>

        <tr
          class="v-centered pricing__supply" 
          v-for="itemProcessing in item.processing"
          :key="`processing-${itemProcessing.id}`">
          <td>
            {{ itemProcessing.processing.processing_type.processing_type_name }}
          </td>
          <td class="border--after">
            {{ itemProcessing.processing.processing_name }}
          </td>
          <td>
            {{ itemProcessing.area | commasep(0) }}
          </td>
          <td class="border--after">
            {{ itemProcessing.processing.unit ? 
              itemProcessing.processing.unit.unit_display_name : '' }}
          </td>
          <td>
            {{ itemProcessing.price | currency(0) }}
          </td>
        </tr>

        <tr 
          class="v-centered pricing__supply"
          v-for="(itemFabrication, fabricationIndex) in item.fabrications"
          :key="`fabrication-${itemFabrication.id}`">
          <td
            class="border--after v-top"
            v-if="fabricationIndex == 0" 
            :rowspan="item.fabrications.length">
            Fabrication
          </td>
          <td>
            {{ itemFabrication.fabrication.fabrication_type.fabrication_type_name }}
          </td>
          <td class="border--after">
            {{ itemFabrication.fabrication.fabrication_name }}
          </td>
          <td>
            {{ itemFabrication.area | commasep(0) }}
          </td>
          <td class="border--after">
            {{ itemFabrication.fabrication.unit.unit_display_name }}
          </td>
          <td>
            {{ itemFabrication.price | currency(0) }}
          </td>
        </tr>

        <tr 
          class="v-centered pricing__install"
          v-for="(itemInstallation, installationIndex) in 
            item.installations.filter(d => 
            ![5,7].includes(d.installation.installation_type_id))"
          :key="`installation-material-${itemInstallation.id}`">
          <td
            class="border--after rotate"
            v-if="installationIndex == 0" 
            :rowspan="item.installations.length">
            <div>Install</div>
          </td>
          <td
            class="border--after"
            v-if="installationIndex == 0" 
            :rowspan="item.installations.filter(d => 
              ![5,7].includes(d.installation.installation_type_id)).length">
            Material
          </td>
          <td>
            {{ itemInstallation.installation.installation_type.installation_type_name }}
          </td>
          <td class="border--after">
            {{ itemInstallation.installation.installation_name }}
          </td>
          <td>
            {{ itemInstallation.area | commasep(0) }}
          </td>
          <td class="border--after">
            {{ itemInstallation.installation.unit.unit_display_name }}
          </td>
          <td>
            {{ itemInstallation.price | currency(0) }}
          </td>
        </tr>

        <tr 
          class="v-centered pricing__install"
          v-for="(itemInstallation, installationIndex) in 
            item.installations.filter(d => 
            [5,7].includes(d.installation.installation_type_id))"
          :key="`installation-labour-${itemInstallation.id}`">
          <td
            class="border--after"
            v-if="item.installations.filter(d => 
            ![5,7].includes(d.installation.installation_type_id)).length == 0" 
            :rowspan="item.installations.length">
            Install
          </td>
          <td
            class="border--after"
            v-if="installationIndex == 0" 
            :rowspan="item.installations.filter(d => 
              [5,7].includes(d.installation.installation_type_id)).length">
            Labour
          </td>
          <td>
            {{ itemInstallation.installation.installation_type.installation_type_name }}
          </td>
          <td class="border--after">
            {{ itemInstallation.installation.installation_name }}
          </td>
          <td>
            {{ itemInstallation.area | commasep(0) }}
          </td>
          <td class="border--after">
            {{ itemInstallation.installation.unit.unit_display_name }}
          </td>
          <td>
            {{ itemInstallation.price | currency(0) }}
          </td>
        </tr>

      </tbody>

      <tfoot>
        <tr class="pricing__total">
          <td 
            colspan="6" 
            class="has-text-weight-bold border--after">
            TOTAL
          </td>
          <td>
            {{ item.total_price | currency(0) }}
          </td>
        </tr>
        <tr class="pricing__total">
          <td 
            colspan="6" 
            class="has-text-weight-bold border--after">
            HST
          </td>
          <td>
            {{ item.total_price * estimation.tax_pct | currency(0) }}
          </td>
        </tr>
        <tr class="pricing__grand-total">
          <td 
            colspan="6" 
            class="has-text-weight-bold border--after">
            TOTAL INCLUDING HST
          </td>
          <td>
            {{ item.total_price * (1+ +estimation.tax_pct) | currency(0) }}
          </td>
        </tr>
      </tfoot>
    </table>

    <div v-if="hasFootnotes" class="help">
      [1] Area is including material waste.
    </div>
  </div>
</template>

<script>
export default {
  props: {
    estimation: {
      type: Object
    },
    itemId: {
      type: [String, Number],
      required: true
    },
    isFullwidth: {
      type: Boolean,
      default: false
    },
    hasFootnotes: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      headers: [
        { label: 'Item', colspan: 2, class: 'pricing__item' },
        { label: 'Description', colspan: 1, class: 'pricing__supply' },
        { label: 'Details', colspan: 1, class: 'pricing__supply border--after' },
        { label: 'Area', colspan: 1, class: 'pricing__supply text--nowrap' },
        { label: 'Unit', colspan: 1, class: 'pricing__supply border--after' },
        { label: 'Cost', colspan: 1, class: 'pricing__supply' }
      ]
    }
  },
  computed: {
    item({ estimation, itemId }) {
      let item = estimation.items.filter(d => d.id == itemId);
      return item ? item[0] : null
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/table.scss';
@import '@/styles/detailed-pricing-cladify.scss'
</style>